import { useEffect, useState } from 'react';

import { AgGridReact } from 'ag-grid-react';

import { useAppSelector } from '@/app/hooks';
import { RootState } from '@/app/store';
import { WithLocalStorage } from '@/components/hoc';
import { useDefaultGridOptions } from '@/grid';

import { useFreezeContext } from '../hooks/useFreezeContext';
import { freezeGradingColumnDefs } from '../utils/columnDefs';
import { defaultGradingRows } from '../utils/constants';
import { FreezeGradingRow } from '../utils/types';

export const FreezeGrading = () => {
  const defaultGridOptions = useDefaultGridOptions();
  const { themeMode } = useAppSelector((state: RootState) => state.preferences);
  const { setGradingGridData, gradingGridKey, gradingGridRef } =
    useFreezeContext();

  const [rowData, setRowData] =
    useState<FreezeGradingRow[]>(defaultGradingRows);

  useEffect(() => {
    setRowData(defaultGradingRows);
    setGradingGridData(undefined);
  }, [gradingGridKey, setGradingGridData]);

  return (
    <div className="freeze-grading-section">
      <div className="pse-grading-grid mb-6">
        <WithLocalStorage storageKey="pseDay7-grid">
          <AgGridReact
            gridOptions={defaultGridOptions}
            ref={gradingGridRef}
            key={gradingGridKey}
            className={`ag-theme-transova${themeMode === 'dark' ? '-dark' : ''}`}
            defaultColDef={{
              resizable: true,
              sortable: false,
              filter: false,
              cellStyle: { textAlign: 'center' },
            }}
            columnDefs={freezeGradingColumnDefs}
            rowData={rowData}
            onCellValueChanged={(params) => {
              const updatedData = rowData.map((row) =>
                row.grade === params.data.grade
                  ? { ...row, [params.column.getId()]: params.newValue }
                  : row,
              );
              setGradingGridData(updatedData);
            }}
          />
        </WithLocalStorage>
      </div>
    </div>
  );
};

export default FreezeGrading;
